import { BindAll } from 'lodash-decorators'
import { EnumApiMy } from '../../api'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'

@BindAll()
export class ControllerCoin extends PagePagination<any> {
  constructor() {
    super({
      url: EnumApiMy.MyPointsTongBan
    })
  }
}
export default ControllerCoin
